import type { Certification } from '@applicator/shared'

import { editorTextActiveClass, editorTextExcludedClass } from '../components/ResumeDetail/editorTypography'

export function certFieldEditorClass(active: boolean): string {
  return active ? editorTextActiveClass : editorTextExcludedClass
}

export function certNameEditorClass(cert: Certification): string {
  return certFieldEditorClass(cert.included && (cert.nameIncluded ?? true))
}

export function certIssuerEditorClass(cert: Certification): string {
  return certFieldEditorClass(cert.included && (cert.issuerIncluded ?? true))
}

export function certDatesEditorClass(cert: Certification): string {
  return certFieldEditorClass(cert.included && (cert.datesIncluded ?? true))
}

export function certUrlEditorClass(cert: Certification): string {
  return certFieldEditorClass(cert.included && (cert.credentialUrlIncluded ?? true))
}
